var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emap-flow-modal-addAssignee" },
    [
      _c(
        "van-popup",
        {
          style: { width: "100%" },
          attrs: { position: "bottom", "get-container": "body" },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("atom-select", {
            attrs: {
              label: "节点",
              type: "picker",
              options: _vm.nodeList,
              "label-key": "nodeName",
              "value-key": "taskId",
              disabled: _vm.nodeList.length == 1,
            },
            on: { confirm: _vm.nodeChange },
            model: {
              value: _vm.form.taskId,
              callback: function ($$v) {
                _vm.$set(_vm.form, "taskId", $$v)
              },
              expression: "form.taskId",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "emap-flow-assignee" }, [
            _c("label", { staticClass: "emap-flow-assignee-label" }, [
              _vm._v("处理人"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "emap-flow-assignee-content",
                on: { click: _vm.showEmapFlowPick },
              },
              [
                _vm._l(_vm.defaultAssigneesObj, function (item) {
                  return _c(
                    "van-tag",
                    {
                      key: item.userId,
                      staticClass: "emap-flow-tag",
                      attrs: { plain: "" },
                    },
                    [_vm._v(_vm._s(item.userName))]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.assigneesObj, function (item) {
                  return _c(
                    "van-tag",
                    {
                      key: item.userId,
                      staticClass: "emap-flow-tag",
                      attrs: { plain: "", type: "primary" },
                    },
                    [_vm._v(_vm._s(item.userName))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.hasMultiInstance
            ? _c(
                "div",
                { staticClass: "emap-flow-assignee" },
                [
                  _c("label", { staticClass: "emap-flow-assignee-label" }, [
                    _vm._v("用户组"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "emap-flow-assignee-content",
                      on: { click: _vm.showGroupPick },
                    },
                    [
                      _vm._l(_vm.defaultInstAssigneesObj, function (item) {
                        return _c(
                          "van-tag",
                          {
                            key: item.userId,
                            staticClass: "emap-flow-tag",
                            attrs: { plain: "" },
                          },
                          [_vm._v(_vm._s(item.userName))]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.instAssigneesObj, function (item) {
                        return _c(
                          "van-tag",
                          {
                            key: item.userId,
                            staticClass: "emap-flow-tag",
                            attrs: { plain: "", type: "primary" },
                          },
                          [_vm._v(_vm._s(item.userName))]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      style: { width: "100%" },
                      attrs: { position: "bottom", "get-container": "body" },
                      model: {
                        value: _vm.groupPopup,
                        callback: function ($$v) {
                          _vm.groupPopup = $$v
                        },
                        expression: "groupPopup",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "van-hairline--top-bottom van-picker__toolbar",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "van-picker__cancel",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.groupPopup = false
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "van-picker__confirm",
                              attrs: { type: "button" },
                              on: { click: _vm.onGroupConfirm },
                            },
                            [_vm._v("确认")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-checkbox-group",
                        {
                          staticClass: "checkbox-group-container",
                          model: {
                            value: _vm.form.instAssignees,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "instAssignees", $$v)
                            },
                            expression: "form.instAssignees",
                          },
                        },
                        [
                          _c(
                            "van-cell-group",
                            _vm._l(_vm.groups, function (item, index) {
                              return _c(
                                "van-cell",
                                {
                                  key: index,
                                  attrs: { clickable: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggle(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "van-checkbox",
                                    {
                                      ref: "groups",
                                      refInFor: true,
                                      staticStyle: { "min-height": "24px" },
                                      attrs: {
                                        name: item.userId,
                                        shape: "square",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.userName) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "van-row",
            [
              _c(
                "van-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { block: "", square: "" },
                      on: {
                        click: function ($event) {
                          _vm.visible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { type: "info", block: "", square: "" },
                      on: { click: _vm.onConfirm },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("emap-flow-pick-m", {
        attrs: {
          multiple: "",
          options: _vm.form.defaultAssignees.concat(_vm.form.assignees),
          keyname: _vm.assigneesName,
          disabledoptions: _vm.form.defaultAssignees,
        },
        on: { "on-confirm": _vm.onCustomConfirm },
        model: {
          value: _vm.customPick,
          callback: function ($$v) {
            _vm.customPick = $$v
          },
          expression: "customPick",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }